import { mutator } from 'satcheljs';
import setFirstRenderCompleted from '../actions/setFirstRenderCompleted';
import { getStore } from '../store/tabStore';

// when opening a new compose tab, the ribbon should be "Message" by default.
// when selecting a pre-existing compose tab, the ribbon tab shouldn't change.
// after the first render of a new compose tab, the MailComposeTabViewState.firstRenderCompleted should be set to true.
mutator(setFirstRenderCompleted, actionMessage => {
    for (const tab of getStore().tabs) {
        if (tab.id === actionMessage.tabId) {
            tab.firstRibbonRenderCompleted = true;
        }
    }
});
